/* ============================================================
   La Nani — când ajunge coletul

   De ce există: o neridicare din două comenzi se întâmplă pentru că omul
   nu știe când vine curierul. Dacă scrie pe pagină „marți 7 octombrie", își
   face socoteala înainte să comande, nu după ce sună curierul.

   Regula cerută de proprietar, 3 octombrie 2026:
     - comandă până la ora 13 → coletul pleacă azi, ajunge MÂINE;
     - comandă după ora 13   → ajunge poimâine.
   Ora 13 nu se scrie nicăieri pe site. E doar pragul de calcul.

   Duminica nu se livrează, deci dacă data căzută e duminică se trece luni.

   De ce în JavaScript și nu în Liquid: Shopify ține paginile în memorie
   cache. Data calculată pe server ar îngheța în pagină și a doua zi ar
   spune tot „mâine, 4 octombrie". Aici se calculează în browser, la
   fiecare deschidere.

   Ceasul telefonului nu e de încredere (fus orar greșit, oameni în
   străinătate), deci ora se citește pentru Europe/Bucharest, nu local.
   ============================================================ */
(function () {
  var ZILE = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  var LUNI = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie',
              'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  var PRAG = 13;

  function acumInRomania() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Bucharest' }));
    } catch (e) {
      return new Date();
    }
  }

  function data() {
    var n = acumInRomania();
    var azi = new Date(n.getFullYear(), n.getMonth(), n.getDate());
    var d = new Date(azi.getTime());
    d.setDate(d.getDate() + (n.getHours() < PRAG ? 1 : 2));
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);   /* duminica se sare */

    var maine = new Date(azi.getTime());
    maine.setDate(maine.getDate() + 1);

    var lung = ZILE[d.getDay()] + ' ' + d.getDate() + ' ' + LUNI[d.getMonth()];
    return {
      eMaine: d.getTime() === maine.getTime(),
      text: d.getTime() === maine.getTime() ? 'mâine, ' + lung : lung
    };
  }

  /* Stilurile vin de aici, nu din foile de stil ale temei: componenta se
     folosește pe pagina obișnuită de produs, pe pagina aerosolului și pe
     paginile de reclamă, fiecare cu alt fișier de stil. Un singur loc. */
  function stiluri() {
    if (document.getElementById('ln-livrare-stil')) return;
    var st = document.createElement('style');
    st.id = 'ln-livrare-stil';
    st.textContent =
      '.ln-livrare{display:flex;align-items:center;gap:13px;margin-top:16px;' +
      'background:#F2F7F3;border:1px solid #D9E5DC;border-radius:10px;' +
      'padding:14px 16px;font-size:15.5px;line-height:1.5;color:#24302A;text-align:left}' +
      '.ln-livrare b{display:block;font-size:16.5px}' +
      '.ln-livrare__i{flex:0 0 auto;font-size:26px;line-height:1}' +
      '.ln-livrare--es{margin:0 0 14px;background:#FFF6E3;border-color:#EFDDB4;color:#4A3A17}' +
      '.ln-livrare--es b{display:inline}';
    document.head.appendChild(st);
  }

  function deseneaza() {
    var d = data();
    stiluri();

    /* în pagină, sub butonul de comandă */
    var locuri = document.querySelectorAll('[data-ln-livrare]:not([data-ln-gata])');
    for (var i = 0; i < locuri.length; i++) {
      var el = locuri[i];
      el.setAttribute('data-ln-gata', '1');
      el.className = (el.className + ' ln-livrare').trim();
      el.innerHTML = '<span class="ln-livrare__i" aria-hidden="true">🚚</span>' +
        '<span>Comanzi acum, coletul ajunge la tine <b>' + d.text + '</b></span>';
      el.hidden = false;
    }
  }

  /* În fereastra EasySell mesajul e altul: acolo omul apasă pe „Comandă", nu
     mai citește, deci i se cere confirmarea că poate prelua coletul în ziua
     aia. Fereastra se construiește din JavaScript-ul lor, după ce pagina e
     gata, deci o așteptăm. */
  function inFormular() {
    var f = document.querySelector('#es-form, #easysell-modal form, .es-modal form');
    if (!f || f.querySelector('.ln-livrare--es')) return;
    stiluri();
    var d = data();
    var cutie = document.createElement('div');
    cutie.className = 'ln-livrare ln-livrare--es';
    cutie.innerHTML = '<span class="ln-livrare__i" aria-hidden="true">📦</span>' +
      '<span>Plasează comanda doar dacă poți prelua coletul <b>' + d.text + '</b>.</span>';

    /* DEASUPRA butonului de finalizare: acolo se citeste inainte de apasare,
       nu dupa. Proprietarul a cerut si varianta de dedesubt, 3 octombrie
       2026, si s-a razgandit in aceeasi zi. */
    var buton = f.querySelector('[type="submit"], .es-submit, .es-order-button, button');
    if (buton && buton.parentNode) buton.parentNode.insertBefore(cutie, buton);
    else f.insertBefore(cutie, f.firstChild);
  }

  function porneste() {
    deseneaza();
    inFormular();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  /* Fereastra lor apare tarziu si se reconstruieste la fiecare deschidere,
     deci urmarim pagina. Cu pauza, ca sa nu lucram la fiecare mutatie: pe o
     pagina cu aplicatii sunt mii. */
  var ceas = 0;
  new MutationObserver(function () {
    if (ceas) return;
    ceas = setTimeout(function () { ceas = 0; porneste(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
